import { INVOICE_IMAGE_EXTENSIONS, INVOICE_PREVIEW_KIND } from "./constants";

/**
 * The document already attached to an invoice, as every payload sends it: the
 * file's own details live in `invoice_meta`, the stored file in `invoice_url`.
 * Returns null when nothing has been attached yet.
 * @param raw an invoice row, one item of the monthly breakdown, or a document PATCH response
 */
export const normalizeInvoiceDocument = (raw = {}) => {
    const url = raw.invoice_url || "";
    if (!url) return null;

    const meta = raw.invoice_meta || {};

    return {
        url,
        name      : meta.original_name || meta.name || "Tax invoice",
        size      : meta.size ?? 0,
        uploadedAt: meta.uploaded_at || null
    };
};

/**
 * Picks the renderer for a stored document. The file name is the only reliable
 * signal — the endpoints return a storage URL without a content type, and
 * those URLs often carry query strings, so the extension is matched against
 * the path only.
 * @param doc a normalized invoice document
 */
export const invoicePreviewKind = (doc) => {
    if (!doc?.url) return INVOICE_PREVIEW_KIND.NONE;

    const path = (doc.name || doc.url).split(/[?#]/)[0].toLowerCase();

    if (path.endsWith(".pdf")) return INVOICE_PREVIEW_KIND.PDF;
    if (INVOICE_IMAGE_EXTENSIONS.some((ext) => path.endsWith(ext))) return INVOICE_PREVIEW_KIND.IMAGE;

    return INVOICE_PREVIEW_KIND.NONE;
};
